import { NgClass } from '@angular/common';
import { Component, Input, OnInit, computed, signal } from '@angular/core';
import { IonIcon } from "@ionic/angular/standalone";
import { addIcons } from 'ionicons';
import { arrowUp } from 'ionicons/icons';

type ColorType = "primary" | "secondary" | "tertiary" | "success" | "warning" | "danger" | "dark" | "medium" | "light" | "white";

interface ButtonState {
  bgColor: ColorType;
  color: ColorType;
  icon: string;
}

@Component({
    selector: 'app-fab',
    templateUrl: './fab.component.html',
    styleUrls: ['./fab.component.scss'],
    imports: [IonIcon, NgClass]
})
export class FabComponent implements OnInit{

  ngOnInit(): void {
    addIcons({ arrowUp });
  }

  state = signal<ButtonState>({
    bgColor: "primary",
    color: "white",
    icon: "arrow-up",
  });

  @Input() set bgColor(value: ColorType) {
    this.state.update(s => ({ ...s, bgColor: value }));
  }
  @Input() set color(value: ColorType) {
    this.state.update(s => ({ ...s, color: value }));
  }
  @Input() set icon(value: string) {
    this.state.update(s => ({ ...s, icon: value }));
  }

  buttonClasses = computed(() => {
    const { bgColor, color } = this.state();
    return {
      [`btn-bg-${bgColor}`]: true,
      [`btn-color-${color}`]: true,
    };
  });

}